import axios from "@/axios";

export const namespaced = true

export const state = {
    unitMeasures: [],
}

export const getters = {
    unitMeasures: state => state.unitMeasures,
}
    
export const mutations = {
    SET_UNIT_MEASURES: (state, response) => state.unitMeasures = response.data, 
}

export const actions = {
    async getUnitMeasures({commit}){
        commit("SET_UNIT_MEASURES", await axios.get('/api/unitmeasures/'))
    }
}
